export const objectKeys = <T extends object>(obj: T): (keyof T)[] =>
  Object.keys(obj) as unknown as (keyof T)[]
